import React, { useEffect } from "react";

import { Alert, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import TopBar from "../components/dashboardParts/TopBar";
import { currentUser } from "system/InfegyUser";
import { setDocumentTitle } from "system/Utilities";
import SimplifiedQuickSearch from "components/widgets/utility/TemplateSearch/SimplifiedQuickSearch";
import SpaceBG from "components/design/SpaceBG";

export default function QuickSearchHome(): JSX.Element {
  const { i18n } = useTranslation();
  const user = currentUser();
  const navigate = useNavigate();

  // If the user cannot run queries, send them to the view only page.
  useEffect(() => {
    if (!user?.permissions?.includes("run_query")) {
      navigate("/viewer-home", { replace: true });
    }
  }, []);

  // Sets document title to default "Infegy Starscape"
  useEffect(() => setDocumentTitle(), []);

  return (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%", height: "100%" }}>
      <Box sx={{ position: "absolute", top: 0, left: 0, width: "100%", zIndex: 100, pl:1, pr: 1 }}>
        <TopBar showLogo={true} />
      </Box>
      <SpaceBG/>
      <SimplifiedQuickSearch/>
    </Box>
  );
}